import { Component, h, Prop } from '@stencil/core';
import Icon from '../svg/bucket.svg'

@Component({
  tag: 'cr-icon-bucket',
  styleUrl: '../cr-icon.css',
  shadow: true,
})
export class CrIconBucket {

  /**
   * The size of the icon - can be 'small', 'medium' or 'large'
   */
  @Prop() size: string

  render() {

    return (
      <div
        class={this.size}
        innerHTML={Icon}
      />
    );
  }

}
